import { useEffect } from 'react';

import { WALLET_NAVIGATE_MESSAGE_TYPE } from '@/ui/utils/messages';
import { useNavigate } from '@/ui/utils/navigation';
import { referrerURL } from '@/utils/referrer';

function NavigateMessageHandler(): null {
  const navigate = useNavigate();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const { type, path } = event.data || {};

      if (
        event.origin !== referrerURL ||
        type !== WALLET_NAVIGATE_MESSAGE_TYPE
      ) {
        return;
      }

      navigate(path);
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, [navigate]);

  return null;
}

export default NavigateMessageHandler;
